import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * El libro de movimientos, dentro del grupo `_contabilidad`.
 *
 * El grupo lo decide la escritura y no la lectura: `rep.movimientos_paginados` no tiene guarda de
 * rol y lo filtra la seguridad por filas, pero el contraasiento que se registra desde acá es de
 * `contador` y `administrador`, que son exactamente los dos que admite `utilidad.ver` de nivel 3.
 */
export const rutaLibroMovimientos = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/libro-movimientos',
  component: lazyRouteComponent(() => import('./libro-movimientos-pantalla.js'), 'RutaLibroMovimientos'),
});
